/*******************************************************************************
Remove Hover Class From An Element
Removes the 'hovering' class from an element.
*******************************************************************************/

export default function removeHoverClass() {
    $(this).removeClass('hovering');
}
